// Small deterministic PRNG (SplitMix32 seeding + xoshiro128**). Integer-only
// so a seed gives the same sequence everywhere.
function splitmix32(seed) {
  let z = seed >>> 0;
  return () => {
    z = (z + 0x9e3779b9) >>> 0;
    let t = z;
    t = Math.imul(t ^ (t >>> 16), 0x85ebca6b);
    t = Math.imul(t ^ (t >>> 13), 0xc2b2ae35);
    return (t ^ (t >>> 16)) >>> 0;
  };
}

export function rand(seed) {
  const sm = splitmix32(seed);
  let a = sm(), b = sm(), c = sm(), d = sm();
  const rotl = (x, k) => ((x << k) | (x >>> (32 - k))) >>> 0;
  const u32 = () => {
    const r = Math.imul(rotl(Math.imul(b, 5) >>> 0, 7), 9) >>> 0;
    const t = (b << 9) >>> 0;
    c ^= a; d ^= b; b ^= c; a ^= d; c ^= t; d = rotl(d, 11);
    return r;
  };
  return {
    u32,
    below: n => u32() % n,                          // 0..n-1
    between: (lo, hi) => lo + (u32() % (hi - lo + 1)), // inclusive
    pick: list => list[u32() % list.length],
    shuffle(list) {
      for (let i = list.length - 1; i > 0; i--) { const j = u32() % (i + 1); [list[i], list[j]] = [list[j], list[i]]; }
      return list;
    },
  };
}

// FNV-1a 32-bit of a string (dates -> seeds).
export function hashText(text) {
  let h = 0x811c9dc5;
  for (let i = 0; i < text.length; i++) h = Math.imul(h ^ text.charCodeAt(i), 0x01000193) >>> 0;
  return h >>> 0;
}
